import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ChatInterface from '../components/ChatInterface';
import Sidebar from '../components/Sidebar';
import { DashboardLoadingState } from '../components/dashboard/DashboardLoadingState';
import { DashboardResizeHandle } from '../components/dashboard/DashboardResizeHandle';
import { useDashboardData } from '../hooks/useDashboardData';
import { useResizableSidebar } from '../hooks/useResizableSidebar';

export default function DashboardPage() {
  const location = useLocation();
  const containerRef = useRef(null);
  const {
    knowledgeBases,
    selectedKB,
    setSelectedKB,
    conversations,
    selectedConversation,
    setSelectedConversation,
    loading,
    loadKnowledgeBases,
    handleNewConversation,
    handleConversationCreated,
  } = useDashboardData(location.search);
  const { sidebarWidth, isResizing, handleMouseDown } = useResizableSidebar(containerRef);

  if (loading) {
    return <DashboardLoadingState />;
  }

  return (
    <div ref={containerRef} className="flex h-screen overflow-hidden bg-background">
      <div style={{ width: sidebarWidth, minWidth: sidebarWidth }} className="flex-shrink-0">
        <Sidebar
          knowledgeBases={knowledgeBases}
          selectedKB={selectedKB}
          onSelectKB={setSelectedKB}
          conversations={conversations}
          selectedConversation={selectedConversation}
          onSelectConversation={setSelectedConversation}
          onNewConversation={handleNewConversation}
          onRefreshKBs={loadKnowledgeBases}
        />
      </div>

      <DashboardResizeHandle isResizing={isResizing} onMouseDown={handleMouseDown} />

      <div className="flex-1 min-w-0">
        <ChatInterface
          selectedKB={selectedKB}
          conversationId={selectedConversation?.id}
          onConversationCreated={handleConversationCreated}
        />
      </div>
    </div>
  );
}
